const GetStarted = () => {
  return (
    <div id="container">
      <strong>Get Started</strong>
    </div>
  );
};

export default GetStarted;
